import React , { useState, useEffect, useCallback} from 'react'
//import CuadroDetalle from './cuadroDetalle';
import Maps from './maps';
import Loader from './Loader';
import Bienvenida from './Bienvenida';
import { notification } from './util/NotificationManager';
import NotificationContainer from './NotificationContainer';
import { Helmet } from 'react-helmet-async';
//import btnDown from  './images/down-line-02.png';
//import btnUp from  './images/down-line-02-I.png';
export default function Mapas() {
    const [coordinates, setCoordinates] = useState(null)
    const [manualPosition,setManualPosition] = useState(null);
    const[filteredData, setFilteredData] = useState([])
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [cargando, setCargando] = useState(false);
    const [Inicial, setInicial] = useState(true);
    const [buttonText,setButtonText] = useState("Buscar a 10 Km");
    const [customText,setCustomText] = useState("de mi ubicación");
    //const targetDown = useRef(null)
    const [sliderValue, setSliderValue] = useState(10)
    const [confirmedSlider, setConfirmedSlider] = useState(10)
    //const [DownBVisible, setDownBVisible] = useState(false)
    //const [UpBVisible, setUpBVisible] = useState(false)

    const handleSearch = async() => {
      setCargando(true);
      if(manualPosition === null){
        const coords = await getLocation();
        if(coords){
          setCoordinates(coords);
          nearSearch(coords.latitude,coords.longitude);
        }
        //nearSearch(coordinates.lat,coordinates.lon);
        //console.log(coords);
      }
      else{
        console.log("posicion cordinates:",coordinates);
        console.log("posicion Manual:",manualPosition);
        if(coordinates.latitude !== manualPosition.lat && coordinates.longitude !== manualPosition.lng){
          //console.log("coordenadas distintas")
          nearSearch(manualPosition.lat,manualPosition.lng);
          setCoordinates({latitude: manualPosition.lat, longitude: manualPosition.lng});
        }
      }
      setCargando(false)
    }

    const getLocation = async () => {
      //console.log("antes de la notificacion")
      setInicial(false)
      //console.log("ingresamos a la funcion getLocation");
        if(isLoading) return

        if (!navigator.geolocation){
            console.error('Geolocation is not supported by this browser.');
            return null;
        }

          //console.log("Si obtenemos la ubicacion");
          setIsLoading(true)

          try {
            const position = await new Promise((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(
                resolve,
                reject,
                { maximumAge: 300000 }
              );
            });
        
            const { latitude, longitude } = position.coords;
            return { latitude, longitude };
          } catch (error) {
            notification(
              "No pudimos obtener tu ubicación, sin embargo puedes mover el punto en el mapa y buscar lugares cercanos",
              "error",
              15000
            );
            return null;
          } finally {
            setIsLoading(false);
          }
      }

      const nearSearch = async (lat, lon) => {
        //console.log("Corriendo nearSearch")
        setCargando(true);
        //console.log("iniciamos la funcion nearsearch");
        //console.log("Latitud: "+lat+" Longitud: "+lon)
          try {
            //console.log("ingresamos al try para la consulta establecimientos-cercanos");
            const response = await fetch(`${process.env.REACT_APP_URL_BACKEND}/establecimientos-cercanos`,{
              method: 'POST',
              headers:{
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({lat, lon})
            })
            if(!response.ok){
              //console.log("no hubo respuesta");
              throw new Error('Failed to fetch data')
            }
            const jsonData = await response.json()
            setData(jsonData)
            //console.log(jsonData)
            setIsLoading(false)
            //console.log("obtuvimos la informacion");
            //setDownBVisible(true);
          } catch (error) {
            console.error('Error fetching data: ', error)
            //console.log("error al obtener la informacion");
            notification('no pudimos obtener la información, intente de nuevo', "error", 5000);
            setIsLoading(false)
          }
          finally{
            setCargando(false)
          }
      }

      const filterData = useCallback(() => {
        //console.log("ingresamos a la funcion de filtrar la informacion para el slider");
        const filtered = data.filter(d => d.distancia <= confirmedSlider); // Filtra solo los datos dentro del rango
        setFilteredData(filtered);
        //console.log("data filtrada:",filtered)
      },[data, confirmedSlider])
    
      useEffect(() => {
        //console.log(data.length)
        if(data.length > 0 && coordinates !== null){
          filterData()
        }
        else if(data.length === 0){
          setFilteredData([]);
        }
      },[data,coordinates,filterData])
      
      const handleSliderChange = (e) => {
        setSliderValue(Number(e.target.value))
      }
      
      const handleSliderRelease = () => {
        setConfirmedSlider(sliderValue);
          setButtonText(`Buscar a ${sliderValue} Km`);
    };

    const setActualLocation = async () =>{
      setCargando(true);
      const coords = await getLocation();
        if(coords){
          setManualPosition(null);
          setCoordinates(coords);
          nearSearch(coords.latitude,coords.longitude);
          setCustomText("de mi ubicación");
        }
        setCargando(false)
    }

      
      /* ---Codigo comentado para los cuadros detalle que por el momento no seran utilizados
      const scrollToDown = () => {
        if(targetDown.current){
          targetDown.current.scrollIntoView({behavior: 'smooth'})
        }
      }
    
      useEffect(() => {
        function handleScroll(){
          if(window.scrollY > 100){
            setUpBVisible(true)
          }
          else{
            setUpBVisible(false)
          }
        }
        window.addEventListener('scroll', handleScroll);
        return() => {
          window.removeEventListener('scroll',handleScroll);
        };
      },[]);
      
    
      const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        setUpBVisible(false)
      }
      */

  return (
    <>
      <Helmet>
        <title>Chamuscón</title>
      </Helmet>
      <div className='Pagina-Principal'>
        <NotificationContainer/>
        {cargando && <Loader/>}
        {Inicial && <Bienvenida/>}
        <Maps data={filteredData} coordinates={coordinates} onManualPosition={setManualPosition} textChange={setCustomText}/>
        <div className='slider-box'>
          <label htmlFor='slider-range'>Distancia:</label>
          <input 
            id='slider-range'
            className='slider' 
            type='range' 
            min='5' max='25' 
            value={sliderValue} 
            onChange={handleSliderChange}
            onMouseUp={handleSliderRelease}
            onTouchEnd={handleSliderRelease}>
          </input>
          <p>{sliderValue} Km</p>
        </div>
        <button className='Boton-Buscar' type='button' onClick={handleSearch}>{buttonText}&nbsp;{customText}</button>
        <div className='my-location-button' onClick={setActualLocation}>
          <div className='location-icon'></div>
        </div>
      </div>
    </>
  )
}
